// Copyright (c) 2026 杨翔宇（武汉文理学院）
// 物理智能教学智能体平台 (Physics Intelligent Agent)
// 保留所有权利 (All Rights Reserved)。未经著作权人书面许可，
// 不得以任何形式复制、传播、修改或用于商业用途。

/**
 * Command Surface API client.
 *
 * Calls the backend command-surface endpoints defined in the slash-command
 * capability surface plan §4.4:
 *   GET  /api/v1/chat/command-surface
 *   POST /api/v1/chat/command-surface/resolve
 *
 * When the backend (Lane A) has not landed yet, callers fall back to the
 * local `DEEP_AGENTS` registry view — see `commandRegistryView.ts`.
 */
import type { AxiosResponse } from 'axios';

import { ApiBase, type ApiRequestConfig } from './apiBase';
import type {
  CommandResolveRequest,
  CommandResolveResponse,
  CommandSurfaceQuery,
  CommandSurfaceResponse,
} from '@/features/command-surface/types';

export class ApiCommandSurface extends ApiBase {
  /** Fetch the command surface for the current actor mode / thread. */
  async getCommandSurface(
    params: CommandSurfaceQuery
  ): Promise<AxiosResponse<CommandSurfaceResponse>> {
    return this.client.get<CommandSurfaceResponse>('/v1/chat/command-surface', {
      params,
      suppressErrorToast: true,
      suppressUnauthorizedRedirect: true,
    } as ApiRequestConfig);
  }

  /** Resolve a set of command invocations into state patches / artifacts. */
  async resolveCommands(
    data: CommandResolveRequest
  ): Promise<AxiosResponse<CommandResolveResponse>> {
    return this.client.post<CommandResolveResponse>(
      '/v1/chat/command-surface/resolve',
      data,
      { suppressErrorToast: true } as ApiRequestConfig
    );
  }
}
